import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { ProviderTask } from '../../models/providerTask';

type Props = {
  healthieId?: number;
};

export const useProviderTasks = ({ healthieId }: Props = {}) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<ProviderTask[], Error>({
    queryKey: ['provider-home-tasks', userToken, healthieId],
    queryFn: () =>
      api({
        route: `/private/dashboard/care-team-member/${healthieId}/tasks`,
        token: userToken,
      }),
    enabled: isAuthenticated && !loading && !!userToken && !!healthieId,
    refetchOnWindowFocus: false,
  });

  return { tasks: data ?? [], isLoading, isError };
};
